export default __webpack_public_path__ + "static/media/anomalies-handled-icon.43c544d1.svg";